import homePressHeight from "./homePressHeight";
import loading from "./loading";

let currentPage = 1;
const DEFAULT_TIME = 1000;
const SHORTER_TIME = DEFAULT_TIME / 2;

const handleTerritoriesFilter = (value, posts) => {
  loading("block");
  const noResults = document.querySelector(".no-results");
  noResults.classList.add("hide");
  const pagination = document.querySelector(".pagination");
  currentPage = 1;
  pagination.style.display = "none";
  posts.forEach((post) => {
    post.classList.add("unmatching");

    if (value === "all") {
      setTimeout(() => {
        loading("none");
        post.classList.remove("unmatching");
        pagination.style.display = "block";
        showPosts(posts, SHORTER_TIME);
        handlePagination(posts);
      }, DEFAULT_TIME);
      return;
    }
    const territories = post.querySelectorAll(".btn-container .btn");
    territories?.forEach((territory) => {
      if (territory.textContent === value) {
        setTimeout(() => {
          loading("none");
          pagination.style.display = "block";
          post.classList.remove("unmatching");
          showPosts(posts, SHORTER_TIME);
          handlePagination(posts);
        }, DEFAULT_TIME);
      }
    });
  });

  setTimeout(() => {
    if (
      Array.from(posts).every((post) => post.classList.contains("unmatching"))
    ) {
      loading("none");
      noResults.classList.remove("hide");
    } else {
      noResults.classList.add("hide");
    }
  }, DEFAULT_TIME);
};

const showPosts = (posts, time = DEFAULT_TIME) => {
  loading("block");
  posts.forEach((post) => {
    post.style.position = "absolute";
    post.style.opacity = 0;
  });
  posts.forEach((post, index) => {
    if (index < 12 * (currentPage - 1) || index > 12 * currentPage - 1) {
      post.classList.add("hide");
    } else {
      post.classList.remove("hide");
    }
  });
  const homePressWrapper = document.querySelectorAll(".home-press__wrapper");

  if (homePressWrapper.length) {
    homePressHeight(homePressWrapper);
  }

  setTimeout(() => {
    loading("none");
    posts.forEach((post) => {
      post.style.position = "relative";
      post.style.opacity = 1;
    });
  }, time);
};

const handleClick = (e, posts, pageContainer) => {
  e.preventDefault();
  const target = e.target;
  currentPage = Number(target.dataset.page);
  showPosts(posts);
  handlePagination(posts, pageContainer);
};

const createPagination = (pages, navLinksContainer) => {
  for (let i = 1; i <= pages; i++) {
    if (i !== currentPage) {
      const page = document.createElement("a");
      page.href = "#";
      page.textContent = i;
      page.dataset.page = i;
      page.classList.add("page-numbers");
      navLinksContainer.appendChild(page);
    } else {
      const page = document.createElement("span");
      page.textContent = i;
      page.dataset.page = i;
      page.classList.add("page-numbers");
      page.classList.add("current");
      navLinksContainer.appendChild(page);
    }
  }
};

const handlePagination = (posts) => {
  const pageContainer = document.querySelector(".pagination");
  const currentPosts = Array.from(posts).filter(
    (post) => !post.classList.contains("unmatching")
  );
  const pages = Math.ceil(currentPosts.length / 12);
  pageContainer.style.display = "block";
  const navLinksContainer = pageContainer.querySelector(".nav-links");
  navLinksContainer.innerHTML = "";
  createPagination(pages, navLinksContainer);

  const pageNumbers = navLinksContainer.querySelectorAll(
    'a[class="page-numbers"]'
  );
  pageNumbers.forEach((page) => {
    page.addEventListener("click", (e) => {
      handleClick(e, posts, pageContainer);
    });
  });
};

export default handleTerritoriesFilter;
export { showPosts, handleClick, handlePagination };
